import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { Box, Divider, Grid2, Stack, useTheme } from '@mui/material'
import { memo } from 'react'

import { X_ACCOUNT_LABEL } from '../../constants/social'
import ProfileStats from '../common/ProfileStats'
import Button from '../shared/button/Button'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import PageTitle from '../shared/pageTitle/PageTitle'
import Text from '../shared/text/Text'
import EarnedStats from './EarnedStats'
import EarnEngagement from './EarnEngagement'
import FollowersMultipliers from './FollowersMultipliers'
import HowToEarn from './HowToEarn'
import RewardedPosts from './RewardedPosts'
import StatusMultipliers from './StatusMultipliers'
import TweetItem from './TweetItem'
import { toUpper } from '../../util/string.helpers'
import Note from './Note'
import { CUSTOM_BRAND_ID } from '../../constants/pointsExchange'
import { xScreenName } from '../../util/pointsExchange.helpers'

const EarnVia = ({
  t,
  earnViaProfile: {
    stats,
    screenName,
    posts,
    connecting,
    currentBrandId,
    error
  },
  connected,
  symbol,
  reqNotMet,
  onCheckReq,
  mainProfile: { tiers, userTier },
  onConnectSocial
}) => {
  const pageTitle = t('earn-via.post-to-earn')
  const theme = useTheme()
  return (
    <>
      <PageTitle
        title={pageTitle}
        desc={t('earn-via.earn-via-x-desc', { symbol })}
      />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <ProfileStats
                title={connected ? xScreenName(screenName) : X_ACCOUNT_LABEL}
                desc={
                  connected
                    ? t('earn-via.connected-account')
                    : t('settings.not-connected')
                }
                stats={[
                  {
                    label: t('earn-via.status-multi'),
                    value: t('earn-via.multi', {
                      value: userTier.tier.metadata?.ugcMultiplier || 0
                    })
                  }
                  // {
                  //   label: t('earn-via.followers'),
                  //   value: formatTicks(100)
                  // },
                  // {
                  //   label: t('earn-via.followers-multi'),
                  //   value: t('earn-via.multi', { value: formatTicks(2000) })
                  // }
                ]}
                displayPic={{
                  ...(connected
                    ? {
                        icon: (
                          <Text
                            label={toUpper(screenName[0])}
                            sx={{ fontWeight: 700, fontSize: 38 }}
                          />
                        )
                        // src: `https://twitter.com/${screenName}/profile_image?size=original`
                      }
                    : {
                        icon: <FaIcon icon={faXTwitter} size='3x' />
                      }),
                  noBorder: true
                }}
                displayPicSx={{
                  backgroundColor: 'common.black',
                  color: 'common.white'
                }}
                banner={
                  <Box
                    sx={{
                      aspectRatio: '16/4',
                      backgroundColor: 'common.black'
                    }}
                  />
                }
                additional={
                  <>
                    <Divider sx={{ borderStyle: 'dashed' }} />
                    <Box p={3}>
                      <Button
                        label={
                          connected
                            ? t('earn-via.change-account')
                            : t('earn-via.connect-account')
                        }
                        variant={connected ? 'outlined' : 'contained'}
                        onClick={() => onConnectSocial(CUSTOM_BRAND_ID.X)}
                        loading={
                          connecting && currentBrandId === CUSTOM_BRAND_ID.X
                        }
                      />
                      {error?.[CUSTOM_BRAND_ID.X] && (
                        <Text
                          label={t(error[CUSTOM_BRAND_ID.X])}
                          color='error'
                          sx={{ mt: 1, textAlign: 'center' }}
                        />
                      )}
                    </Box>
                  </>
                }
                statColumns={1}
              />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <EarnedStats t={t} stats={stats} symbol={symbol} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <HowToEarn
                t={t}
                symbol={symbol}
                maxPosts={userTier.tier.metadata?.ugcMaxPostsRewarded || 0}
              />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Stack spacing={3}>
            <RewardedPosts
              t={t}
              reqNotMet={reqNotMet}
              onCheckReq={onCheckReq}
              connected={connected}
            />
            {posts.map((post, index) => (
              <TweetItem
                key={index}
                theme={theme}
                t={t}
                symbol={symbol}
                {...post}
              />
            ))}
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <EarnEngagement t={t} symbol={symbol} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <StatusMultipliers t={t} symbol={symbol} tiers={tiers} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <FollowersMultipliers t={t} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <Note t={t} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(EarnVia)
